import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import App from './App.tsx'
import ErrorBoundary from './components/ErrorBoundary'
import { queryClient } from './queryClient'
import './index.css'

import { ThemeProvider as NextThemesProvider } from 'next-themes'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <NextThemesProvider attribute="class" defaultTheme="dark">
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </NextThemesProvider>
    </QueryClientProvider>
  </React.StrictMode>,
)
